<template>
    <div id="abcActivityAddEdit">
        <div class="top">
            <el-button @click="$router.go(-1)" type="default" size="medium">返回</el-button>
            <el-button size="medium" type="primary" @click="onsave">保存</el-button>
        </div>
        <div class="body" :style="`height: ${windowHeight-180}px;`">
            <div style="width: 810px;padding-top:20px;margin: 0 auto;">
                <el-form :model="formData" :rules="rules" ref="form" label-width="140px" class="demo-ruleForm">
                    <el-form-item label="活动名称" prop="title">
                        <el-input v-model="formData.title" :maxlength="45" placeholder="请输入活动名称"
                                  @blur="$event.target.value = $event.target.value.trim();"></el-input>
                    </el-form-item>
                    <el-form-item
                        label="排序号"
                        prop="orderNum"
                    >
                        <el-input-number
                            label="排序号"
                            :min="0"
                            :max="9999"
                            v-model="formData.orderNum"
                        ></el-input-number>
                    </el-form-item>

                    <el-form-item label="活动范围" required="">
                        <location-selector v-model="locationArray"
                                           noDist
                                           ref="locationSelector"></location-selector>
                    </el-form-item>
                    <el-form-item label="活动链接" prop="url">
                        <el-input v-model="formData.url" :maxlength="200" placeholder="请输入活动链接"
                                  @blur="$event.target.value = $event.target.value.trim();"></el-input>
                    </el-form-item>
                    <el-form-item label="活动封面" prop="photoList">
                        <uploader ref="coverUploader" pathPrefix="abcActivity" openDelete
                                  :extList="['bmp', 'png', 'jpg', 'jpeg', 'gif']" showResult="image"
                                  showMode="button" v-model="photoList"></uploader>
                    </el-form-item>
                </el-form>
            </div>
        </div>
    </div>
</template>

<script>
    import LocationSelector from '@/components/LocationSelector';
    import BackTool from '@/components/BackTool';
    import Uploader from '@/components/Uploader/WebUploader';
    import {updateAbcActivitySet, addAbcActivitySet, getAbcActivitySet} from '@/api/abcActivityManagement';
    import mixin from "@/mixins/windowResize";

    export default {
        name: 'abcActivityAddEdit',
        components: {BackTool, Uploader, LocationSelector},
        data() {
            const validatephotoList = (rule, value, callback) => {
                if (this.photoList.length === 0) {
                    callback(new Error('请上传活动封面'));
                } else {
                    callback();
                }
            };
            return {
                id: this.$route.query.id,
                isEdit: !!this.$route.query.id,

                photoList: [],
                formData: {
                    title: '',
                    orderNum: 1,
                    url: ''
                },
                locationArray: ['320000', '320100', '0'],
                rules: {
                    photoList: [
                        {required: true, validator: validatephotoList}
                    ],
                    title: [
                        {required: true, message: '请输入活动名称', trigger: 'blur'},
                    ],
                    orderNum: [
                        {required: true, message: '请输入排序号', trigger: 'blur'},
                    ],
                    url: [
                        {required: true, message: '请输入活动链接', trigger: 'blur'},
                    ],
                },
            }
        },
        mixins: [mixin],
        created() {
            if(this.isEdit) {
                getAbcActivitySet({
                    abcActivitySetId: this.id
                })
                    .then(res => res.data)
                    .then(data => {
                        console.log(data);
                        const pageData = data.data;
                        this.locationArray = [`${pageData.orgAreaCode.slice(0, 2)}0000`, `${pageData.orgAreaCode.slice(0, 4)}00`, pageData.orgAreaCode];
                        this.photoList = [{
                            fileUrl: pageData.photoUrl
                        }];
                        this.formData = pageData;
                    })
            }
        },
        methods: {
            onsave() {
                this.$refs.form.validate(isValid => {
                    if (isValid) {
                        const args = {
                            infoJson: "",
                            orderNum: this.formData.orderNum,
                            orgAreaName: this.$refs.locationSelector.getNameArray().join(' '),
                            orgAreaCode: this.$refs.locationSelector.getCode(),
                            photoUrl: this.photoList[0].fileUrl,
                            state: 1,
                            title: this.formData.title,
                            url: this.formData.url
                        };
                        new Promise(resolve => {
                            if(this.isEdit) {
                                args.id = this.id;
                                updateAbcActivitySet(args)
                                    .then(res => res.data)
                                    .then(resolve)
                            } else {
                                addAbcActivitySet(args)
                                    .then(res => res.data)
                                    .then(resolve)
                            }
                        })
                            .then(data => {
                                if(data.result) {
                                    this.$message.success(`${this.isEdit ? "编辑" : "新增"}完成`);
                                    setTimeout(() => {
                                        this.$router.back();
                                    }, 500)
                                }
                            })
                    }
                })
            }
        }
    }
</script>

<style lang="scss" scoped>
    #abcActivityAddEdit {
        padding: 12px;
    }
</style>



// WEBPACK FOOTER //
// src/views/abcActivityManagement/abcActivityAddEdit.vue